import React, { useState } from 'react';
import styles from '../style.module.scss';

import { OverlayTrigger, Popover, Form, Modal, Button } from 'react-bootstrap';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { useHistory } from 'react-router-dom';
import NewHeaderComponent from '../../../components/NewHeader/NewHeader';
import InputComponent from '../../../components/Input';
import { handleTypeNumber } from '../../../utils/utils';
import { arzoooS3Url } from '../../../utils/checkMode';

const ProductCard = (props) => {
  const { data } = props;
  const suggestedPriceTooltip = localStorage.getItem('suggestedTooltipDisabled');

  const [tooltipShown, setTooltipShown] = useState(!suggestedPriceTooltip);
  return (
    <div className={`${styles.productCardContainer}`}>
      {data?.ranking > 5 ? (
        <span className={`${styles.recommendedTop}`}>Top Selling</span>
      ) : (
        <span className={`${styles.recommendedFast}`}>Fast Selling</span>
      )}
      <div className={`${styles.productImg}`}>
        <img
          src={`${arzoooS3Url}/images/products/${data?.img_hash}`}
          // src="/images/Refrigerator.png"
        />
      </div>
      <div className={`${styles.productDetails}`}>
        <div className={`${styles.productTitle}`}>{data?.title}</div>
        <div className={`mt-2 ${styles.productBrand}`}>by {data?.brand}</div>
        <OverlayTrigger
          trigger="click"
          placement="right"
          id={`overlay_${props.id}`}
          show={props?.showAddProduct && props?.addProductObj.productId == data?.productId}
          overlay={
            <Popover
              id={`ppopover-basic_${props.id}`}
              className={`${styles.addProductPopup}`}
              style={{
                overflowY: 'auto',
              }}
            >
              <ClickAwayListener
                onClickAway={() => {
                  props.setShowAddProduct(false);
                }}
              >
                <Popover.Content>
                  <div className={`mt-3 ${styles.businessInputContainer}`}>
                    {props.addProductObj?.quantity && <span>Enter Quantity</span>}
                    <InputComponent
                      // disabled={callbackLoading ? true : false}
                      type="number"
                      className={`${styles.businessInputBox} bg-white`}
                      onKeyDown={(evt) => handleTypeNumber(evt)}
                      value={props.addProductObj?.quantity || ''}
                      placeholder={'Enter Quantity'}
                      name="quantity"
                      handleChange={(e) => {
                        props.productObj(e);
                      }}
                    />
                  </div>

                  <div className={`mt-3 ${styles.businessInputContainer}`}>
                    {props.addProductObj?.price && <span>Enter Price</span>}
                    {props.addProductObj?.suggested_price && (
                      <span className={`${styles.suggestedPrice}`}>
                        Suggested Price: ₹{props.addProductObj?.suggested_price}
                      </span>
                    )}
                    <span className={`${styles.rupee}`}>₹</span>
                    <InputComponent
                      // disabled={callbackLoading ? true : false}
                      type="number"
                      className={`${styles.businessInputBox} ${styles.inputWithRupee} bg-white`}
                      onKeyDown={(evt) => handleTypeNumber(evt)}
                      value={props.addProductObj?.price || ''}
                      placeholder={'Enter Price'}
                      name="price"
                      handleChange={(e) => {
                        props.productObj(e);
                      }}
                    />
                  </div>
                  {!suggestedPriceTooltip && tooltipShown && (
                    <Popover
                      id={`ppopover-${props.id}`}
                      className={`${styles.suggestedPriceTooltip}`}
                      style={
                        {
                          // overflowY: 'auto',
                        }
                      }
                    >
                      <Popover.Content>
                        <div className="d-flex justify-content-between align-items-start">
                          <span>
                            Check price suggestion to set lowest price and get maximum sales
                          </span>
                          <img
                            className={`mt-1 ${styles.cursorP}`}
                            src="/images/cancel.svg"
                            onClick={() => {
                              setTooltipShown(false);
                              localStorage.setItem('suggestedTooltipDisabled', true);
                            }}
                          />
                        </div>
                      </Popover.Content>
                    </Popover>
                  )}
                  {props?.errorMsg && (
                    <div className={`${styles.errorMessage} mt-2`}>{props?.errorMsg}</div>
                  )}
                  <div className="pt-3 d-flex justify-content-center align-items-center">
                    <button
                      disabled={
                        props?.errorMsg
                          ? true
                          : props?.addLoading ||
                            (props.addProductObj?.price && props.addProductObj?.quantity)
                          ? false
                          : true
                      }
                      className={`btn ${styles.addBtn}`}
                      onClick={() => {
                        props.addInv();
                      }}
                    >
                      ADD
                    </button>

                    <button
                      disabled={props?.addLoading}
                      className={`${styles.discardBtn} ml-2 btn`}
                      onClick={() => {
                        props.setShowAddProduct(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </Popover.Content>
              </ClickAwayListener>
            </Popover>
          }
        >
          <button
            onClick={() => {
              props.selectedModelFnc(data?.model, 'exsisting', data, true);
              props?.setShowAddProduct(true);
              props?.setErrorMsg(null);
              // props.handleInvModal(true);
            }}
            className={`mt-3 ${styles.addRecommendedProductButton}`}
          >
            <span>ADD</span>
          </button>
        </OverlayTrigger>
      </div>
    </div>
  );
};
export default ProductCard;
